
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class HoldingClassWeightGrid extends SiteEntityGrid<HoldingClassWeightRow, any> {
        protected getColumnsKey() { return 'Rebalancer.HoldingClassWeight'; }
        protected getDialogType() { return HoldingClassWeightDialog; }
        protected getIdProperty() { return HoldingClassWeightRow.idProperty; }
        protected getLocalTextPrefix() { return HoldingClassWeightRow.localTextPrefix; }
        protected getService() { return HoldingClassWeightService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}